// ===== REVIEWS.io: Sterne unter den Produkttitel verschieben =====
(function () {
  function moveRatingSnippet() {
    var rating = document.querySelector('.ruk_rating_snippet');
    var titel = document.querySelector('.product__title');
    if (!rating || !titel) return;
    var block = rating.closest('.shopify-block') || rating;
    if (block.getAttribute('data-mac-moved')) return;
    block.setAttribute('data-mac-moved', '1');
    titel.insertAdjacentElement('afterend', block);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(moveRatingSnippet, 800); });
  } else {
    setTimeout(moveRatingSnippet, 800);
  }
})();
